export default __webpack_public_path__ + "static/media/Amplitude-Light.16bbf025.otf";